import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';
import { GlobalStyle } from './components/GlobalStyle';
import { I18nProvider } from './i18n';

const GA_ID = process.env.REACT_APP_GA_ID || 'G-91VW3XW0CX';

if (process.env.NODE_ENV === 'production') {
  try {
    Object.defineProperty(window, '__REACT_DEVTOOLS_GLOBAL_HOOK__', {
      value: {
        isDisabled: true,
        inject: function() {},
        onCommitFiberRoot: function() {},
        onCommitFiberUnmount: function() {}
      }
    });
  } catch {}
  try {
    ['log', 'debug', 'info'].forEach((k) => { console[k] = () => {}; });
  } catch {}
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <App />
      </ThemeProvider>
    </I18nProvider>
  </React.StrictMode>
);

function hasConsent() {
  try {
    const v = window.localStorage.getItem('berrik_cookie_consent');
    const p = v ? JSON.parse(v) : null;
    return p && p.value === 'accepted';
  } catch {
    return false;
  }
}

function loadGtag(id) {
  if (!id) return;
  if (!window.gtag) {
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    window.gtag('js', new Date());
  }
  window.gtag('config', id, { anonymize_ip: true });
}

function sendVitals(metric) {
  if (!hasConsent()) return;
  const payload = { name: metric.name, id: metric.id, value: metric.value, rating: metric.rating, path: window.location.pathname };
  if (process.env.NODE_ENV !== 'production') return;
  if (window.gtag) {
    window.gtag('event', 'web_vitals', payload);
  }
}

if (hasConsent()) {
  loadGtag(GA_ID);
}

window.addEventListener('cookie-consent-accepted', () => {
  loadGtag(GA_ID);
  const payload = { type: 'pageview', path: window.location.pathname, title: document.title, referrer: document.referrer || '' };
  if (process.env.NODE_ENV !== 'production') return;
  if (window.gtag) {
    window.gtag('event', 'page_view', { page_path: payload.path, page_title: payload.title });
  }
});

reportWebVitals(sendVitals);
